import { createReducer } from 'reduxsauce';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { ChangePasswordTypes } from '../actions/ChangePasswordActions';
import { isEmpty } from '../../services/Validation';

/* ------------- Initial ChangePassword State ------------- */
export const INITIAL_STATE = Immutable({
  error: '',
  changingPassword: false,
  currentPassword: '',
  showCurrentPasswordError: false,
  newPassword: '',
  showNewPasswordError: false,
  canChangePassword: false,
  passwordChanged: false,
});

/* ------------- Reducers ------------- */
export const onChangePasswordRequest = (state) =>
  state.merge({ changingPassword: true });
export const onChangePasswordSuccess = (state) =>
  state.merge({ changingPassword: false, passwordChanged: true });
export const onChangePasswordFailure = (state, { error }) =>
  state.merge({ changingPassword: false, error });
export const onCurrentPasswordChange = (state, { currentPassword }) =>
  state.merge({ currentPassword, showPasswordError: true });
export const onNewPasswordChange = (state, { newPassword }) =>
  state.merge({ newPassword, showConfirmPasswordError: true });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [ChangePasswordTypes.CHANGE_PASSWORD_REQUEST]: onChangePasswordRequest,
  [ChangePasswordTypes.CHANGE_PASSWORD_SUCCESS]: onChangePasswordSuccess,
  [ChangePasswordTypes.CHANGE_PASSWORD_FAILURE]: onChangePasswordFailure,
  [ChangePasswordTypes.CURRENT_PASSWORD_CHANGED]: onCurrentPasswordChange,
  [ChangePasswordTypes.NEW_PASSWORD_CHANGED]: onNewPasswordChange,
});

/* ------------- Selectors ------------- */
export const isChangingPassword = (state) =>
  state.changePassword.changingPassword;
export const passwordChanged = (state) => state.changePassword.passwordChanged;
export const getError = (state) => state.changePassword.error;
export const getCurrentPassword = (state) =>
  state.changePassword.currentPassword;
export const getNewPassword = (state) => state.changePassword.newPassword;
export const shouldShowCurrentPasswordError = (state) =>
  state.changePassword.showCurrentPasswordError;
export const shouldShowNewPasswordError = (state) =>
  state.changePassword.showNewPasswordError;

// memoized
export const getCurrentPasswordError = createSelector(
  getCurrentPassword,
  (password) => (isEmpty(password) ? 'Password is required' : '')
);
export const getNewPasswordError = createSelector(
  [getNewPassword, getCurrentPassword],
  (newPassword, password) => {
    if (isEmpty(newPassword)) return 'Confirmation password is required';
    if (password !== newPassword) return 'Passwords must match';
    return '';
  }
);
export const canChangePassword = createSelector(
  [getNewPasswordError],
  (passwordError) => passwordError.length === 0
);



// WEBPACK FOOTER //
// ./src/state/reducers/ChangePasswordReducer.js